import { Grid, ListItem, Paper, Table, TableBody, TableCell, TableHead, TableRow, Tooltip, makeStyles } from "@material-ui/core"
import NotInterestedIcon from '@material-ui/icons/NotInterested';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import React from "react"
import { UtilsDate } from '../../../../app/orussystem/utils/UtilDate'


const useStyles = makeStyles((theme) => ({
    seeMore: {
        marginTop: theme.spacing(3),
    },
    box: {
        display: "flex",
    },
    spreadBox: {
        justifyContent: "space-between",
        alignItems: "center"
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: 320,
    },
    tableAction: {
        paddingLeft: 0,
        paddingRight: 0,
        margin: "0 auto",
        textAlign: "center",
        alignItems: "center"
    },
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '600px',
        margin: 'auto'

    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        borderRadius: '10px'
    },
    paperContent: {
        backgroundColor: process.env.REACT_APP_PRIMARY_THEMA,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(1, 1, 1),
        borderRadius: '10px'
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        fontSize: 14,
    },
    pos: {
        marginBottom: 12,
    },
    card: {
        padding: theme.spacing(3),
        marginBottom: theme.spacing(2),
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        borderRadius: '10px',
        height: '80px',
        marginTop: '-3%',
        marginBottom: '3.2%'
    },
    cardContent: {
        display: 'flex',
        flexDirection: 'column',
    },
    cardActions: {
        display: 'flex',
        justifyContent: 'space-between',
    },
}));



export const ListAños = ({ rows, openModalEdit, classes, changeRol, changeStatus, changeMachine, isLoanding }) => {

    const r = rows !== undefined && rows !== null ? rows : []
    const clases = useStyles()

    const validateRowsTable = (item) => {

        if (item !== undefined && item !== null) {
            return item
        } else {
            return "---"
        }

    }

    return (

        <>

            {isLoanding ? <>Cargando...</> : r.map((row) => (
                <Paper
                    key={row.id} className={clases.card}>
                    <Grid container spacing={1}>
                        <Grid item style={{ width: '22%', paddingLeft: '1%', fontWeight: 'bold', fontSize: '16px' }}>
                            {validateRowsTable(row.year)}
                        </Grid>
                        <Grid item style={{ width: '22%', paddingLeft: '1%', fontWeight: 'bold', fontSize: '16px' }}>
                            {UtilsDate().formatDDMMMYYYYHHmm(new Date(row.date_created))}
                        </Grid>
                        <Grid  style={{ width: '28%', paddingLeft: '9%', fontWeight: 'bold', fontSize: '16px' }}>
                            {validateRowsTable(row.active != false ? 'Activo' : 'Inactivo')}
                        </Grid>
                        <Grid item xs={1} style={{ width: '18%', paddingLeft: '0%' }} onClick={() => { changeStatus(row) }}>
                            <ListItem button  >
                                <Tooltip title={row.active ? "Inhabilitar" : "Habilitar"} aria-label="top-end">
                                    {row.active ? <NotInterestedIcon color="primary" style={{ marginLeft: '38%' }} /> : <CheckCircleOutlineIcon color="primary" style={{ marginLeft: '38%' }} />}
                                </Tooltip>
                            </ListItem>
                        </Grid>

                    </Grid>
                </Paper>
            ))}


        </>
    )
}